export const PageMode = {
    Builder: "Builder",
    Editor: "Editor",
    RedirectUrl: "Redirect URL",
};